export default __webpack_public_path__ + "static/media/logo disdik special request for web.dc49fee7.png";